const angular = require('angular');

module.exports = function ($provide) {
    $provide.decorator('$state', [
        '$delegate', '$stateParams', '$injector', function ($state, $stateParams, $injector) {
            $state.shouldGetMetaData = function () {
                const toState = $state.current;
                return !toState.data || (toState.data && toState.data.shouldGetMetadata !== false);
            };

            $state.getMetadata = function () {
                const toState = $state.current;
                if (toState.data && toState.data.pageMetadata) {
                    return angular.isArray(toState.data.pageMetadata)
                        ? $injector.invoke(toState.data.pageMetadata)
                        : toState.data.pageMetadata;
                }

                return {
                    title: '',
                    metaDescription: '',
                };
            };

            $state.shouldAuthenticate = function (toState, toParams) {
                return $injector.invoke(toState.data.authenticate, undefined, { toParams });
            };
            return $state;
        },
    ]);
};



// WEBPACK FOOTER //
// ./src/configuration/state.js